const IconShield = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill={props.fill}
      stroke={props.stroke}
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 2.5L16.25 5.1V10.2C16.25 14.3 13.5 16.4 10 17.5C6.5 16.4 3.75 14.3 3.75 10.2V5.1L10 2.5Z"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 9.9L9.25 11.65L12.5 8.4"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default IconShield
